import { PlanDataTypeEnum } from 'api/client';
import { ReactComponent as LeaveIcon } from 'assets/icons/icon-leave-early.svg';
import { ReactComponent as StayIcon } from 'assets/icons/icon-stay-defend.svg';
import { CopyWrapper, IconWrapper } from 'components/alert/alert.styles';
import { H5 } from 'components/headings';
import Link from 'next/link';
import { FC } from 'react';
import { getPlanTitle } from 'utils/helpers';
import { PlanStatusCardStyled } from './plan-status-card.styles';

interface Props {
  planType: PlanDataTypeEnum;
  address?: string;
  href: string;
  planName?: string;
  handleClick: () => void;
}

const PlanStatusCard: FC<Props> = ({
  planType,
  address,
  href,
  planName,
  handleClick,
}) => {
  const title = getPlanTitle(planType);

  return (
    <Link href={href} passHref>
      <PlanStatusCardStyled as='a' onClick={handleClick}>
        <IconWrapper>
          {planType === PlanDataTypeEnum.Leave && <LeaveIcon />}
          {planType === PlanDataTypeEnum.Stay && <StayIcon />}
        </IconWrapper>
        <CopyWrapper>
          <H5 as='strong'>{planName || title}</H5>
          {address}
        </CopyWrapper>
      </PlanStatusCardStyled>
    </Link>
  );
};

export default PlanStatusCard;
